import React, { useState, useEffect } from "react";
import { TextField, IconButton, Select, MenuItem, FormControl, Switch } from "@material-ui/core";
import { Delete as DeleteIcon, Check as CheckIcon } from "@material-ui/icons";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const STATUS_OPTIONS = [
  { value: "open", label: "Aberto" },
  { value: "pending", label: "Pendente" },
  { value: "closed", label: "Fechado" },
  { value: "group", label: "Grupo" },
];

// boardId = board ONDE ESTA REGRA VIVE (fases desse board alimentam o
// gatilho "Card entrou na fase" e, se o destino for o mesmo board, o
// "mover para" tambem). boards = lista de todos os boards da empresa,
// pro seletor de destino - pedido do usuario 2026-09-28 ("quando o card
// chegar na fase Ganhos ele ir para o board Implantacao").
const MovementRuleFormFields = ({ rule, boardId, boards, phases, tags, onSave, onDelete }) => {
  const [name, setName] = useState(rule?.name || "");
  const [triggerType, setTriggerType] = useState(rule?.triggerType || "ticket_status");
  const [triggerValue, setTriggerValue] = useState(rule?.triggerValue || "");
  const [targetBoardId, setTargetBoardId] = useState(
    rule?.targetBoardId ? String(rule.targetBoardId) : ""
  );
  const [targetPhaseId, setTargetPhaseId] = useState(rule?.targetPhaseId || "");
  const [active, setActive] = useState(rule?.active !== false);
  const [targetBoardPhases, setTargetBoardPhases] = useState([]);
  const isNew = !rule;

  // Fases do board selecionado como destino - so' busca quando o
  // destino e' um board DIFERENTE do atual (senao reaproveita a prop
  // "phases", que ja e' esse mesmo board).
  useEffect(() => {
    const isDifferentBoard = targetBoardId && targetBoardId !== String(boardId);
    if (!isDifferentBoard) {
      setTargetBoardPhases([]);
      return;
    }
    (async () => {
      try {
        const { data } = await api.get(`/boards/${targetBoardId}`);
        setTargetBoardPhases(data.phases || []);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [targetBoardId, boardId]);

  const targetPhaseOptions =
    targetBoardId && targetBoardId !== String(boardId) ? targetBoardPhases : phases;

  const handleSave = (overrides = {}) => {
    const values = {
      name,
      triggerType,
      triggerValue,
      // "" = mesmo board da regra (backend entende ausencia/vazio assim).
      targetBoardId: targetBoardId && targetBoardId !== String(boardId) ? targetBoardId : "",
      targetPhaseId,
      active,
      ...overrides,
    };
    // "manual" aceita triggerValue vazio de proposito (= botao
    // disponivel em qualquer fase deste board) - os outros tres tipos
    // continuam exigindo um valor escolhido.
    if ((values.triggerType !== "manual" && !values.triggerValue) || !values.targetPhaseId) return;
    onSave(values);
    if (isNew) {
      setName("");
      setTriggerType("ticket_status");
      setTriggerValue("");
      setTargetBoardId("");
      setTargetPhaseId("");
      setActive(true);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
      <TextField
        size="small"
        variant="outlined"
        placeholder="Nome (opcional)"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onBlur={!isNew ? () => handleSave() : undefined}
        style={{ minWidth: 140 }}
      />
      <FormControl size="small" variant="outlined">
        <Select
          value={triggerType}
          onChange={(e) => {
            setTriggerType(e.target.value);
            setTriggerValue("");
            if (!isNew) handleSave({ triggerType: e.target.value, triggerValue: "" });
          }}
        >
          <MenuItem value="ticket_status">Status do ticket muda para</MenuItem>
          <MenuItem value="tag_applied">Tag aplicada</MenuItem>
          <MenuItem value="phase_reached">Card entrou na fase (automatico)</MenuItem>
          <MenuItem value="manual">Botao manual no card</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" variant="outlined" style={{ minWidth: 140 }}>
        <Select
          value={triggerValue}
          onChange={(e) => {
            setTriggerValue(e.target.value);
            if (!isNew) handleSave({ triggerValue: e.target.value });
          }}
          displayEmpty
        >
          {triggerType === "manual" ? (
            <MenuItem value="">
              <em>Qualquer fase deste quadro</em>
            </MenuItem>
          ) : (
            <MenuItem value="">
              <em>Selecione</em>
            </MenuItem>
          )}
          {triggerType === "ticket_status" &&
            STATUS_OPTIONS.map((s) => (
              <MenuItem key={s.value} value={s.value}>
                {s.label}
              </MenuItem>
            ))}
          {triggerType === "tag_applied" &&
            tags.map((t) => (
              <MenuItem key={t.id} value={String(t.id)}>
                {t.name}
              </MenuItem>
            ))}
          {(triggerType === "phase_reached" || triggerType === "manual") &&
            phases.map((p) => (
              <MenuItem key={p.id} value={String(p.id)}>
                {triggerType === "manual" ? `Só na fase: ${p.name}` : p.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <span style={{ fontSize: 13, color: "#888" }}>→ mover para</span>
      <FormControl size="small" variant="outlined" style={{ minWidth: 140 }}>
        <Select
          value={targetBoardId || String(boardId)}
          onChange={(e) => {
            const newBoardId = e.target.value;
            setTargetBoardId(newBoardId);
            setTargetPhaseId("");
            if (!isNew) {
              handleSave({
                targetBoardId: newBoardId !== String(boardId) ? newBoardId : "",
                targetPhaseId: "",
              });
            }
          }}
        >
          {boards.map((b) => (
            <MenuItem key={b.id} value={String(b.id)}>
              {String(b.id) === String(boardId) ? `${b.name} (este board)` : b.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" variant="outlined" style={{ minWidth: 140 }}>
        <Select
          value={targetPhaseId}
          onChange={(e) => {
            setTargetPhaseId(e.target.value);
            if (!isNew) handleSave({ targetPhaseId: e.target.value });
          }}
          displayEmpty
        >
          <MenuItem value="">
            <em>Selecione a fase</em>
          </MenuItem>
          {targetPhaseOptions.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!isNew && (
        <Switch
          size="small"
          checked={active}
          onChange={(e) => {
            setActive(e.target.checked);
            handleSave({ active: e.target.checked });
          }}
        />
      )}
      {isNew ? (
        <IconButton
          size="small"
          onClick={() => handleSave()}
          disabled={(triggerType !== "manual" && !triggerValue) || !targetPhaseId}
        >
          <CheckIcon />
        </IconButton>
      ) : (
        <IconButton size="small" onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default MovementRuleFormFields;
